import { render, staticRenderFns } from "./RecentChatProfile.vue?vue&type=template&id=5e94b4dc&scoped=true"
import script from "./RecentChatProfile.vue?vue&type=script&lang=js"
export * from "./RecentChatProfile.vue?vue&type=script&lang=js"
import style0 from "./RecentChatProfile.vue?vue&type=style&index=0&id=5e94b4dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e94b4dc",
  null
  
)

export default component.exports